import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { sponsors } from "../../lib/images";
import "./sponsorBanner.styles.scss";

const SponsorLogo = ({ sponsor }) => (
  <a
    className={sponsor.link ? "" : "disable-link"}
    href={sponsor.link}
    target="_blank"
    rel="noreferrer"
  >
    <Image src={sponsor.src} alt={sponsor.altTxt} />
  </a>
);

function SponsorBanner() {
  return (
    <div>
      <div id="about-us">
        <Container className="sponsor-banner">
          <Row noGutters>
            <Col xs="12">
              {/* Desktop layout (lg and up): top row of 4, bottom row of 3 centered */}
              <Container className="sponsor-container d-none d-lg-block">
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  {sponsors.slice(0, 3).map((sponsor, index) => (
                    <Col key={index} lg={4} xl={4}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  {sponsors.slice(3, 5).map((sponsor, index) => (
                    <Col key={index + 3} lg={5} xl={5}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    margin: "15px",
                  }}
                >
                  {sponsors.slice(5).map((sponsor, index) => (
                    <Col key={index + 5} lg={4} xl={4}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
              </Container>
              {/* Mobile/tablet layout (below lg): responsive wrapping grid */}
              <Container className="sponsor-container d-lg-none">
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {sponsors.slice(0, 2).map((sponsor, index) => (
                    <Col key={index} xs={6} sm={6} md={6}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {sponsors.slice(2, 4).map((sponsor, index) => (
                    <Col key={index + 2} xs={6} sm={6} md={6}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {sponsors.slice(4, 6).map((sponsor, index) => (
                    <Col key={index + 4} xs={6} sm={6} md={6}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    margin: "0px 30px",
                  }}
                >
                  {sponsors.slice(6).map((sponsor, index) => (
                    <Col key={index + 6} xs={6} sm={6} md={6}>
                      <SponsorLogo sponsor={sponsor} />
                    </Col>
                  ))}
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default SponsorBanner;